import {
    Box,
    Button,
    Container,
    Flex,
    FormControl,
    FormErrorMessage,
    FormLabel,
    Text,
    Textarea,
    useToast
} from "@chakra-ui/react";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { HiArrowNarrowLeft } from "react-icons/hi";
import { useNavigate, useParams } from "react-router-dom";
import { IDiscussionTopic } from "../../../models/trainer-discussiontopic.model";
import trainercoursesService from "../../../services/trainer/trainercourses.service";
import courseRoutes from "../../courses/courseRoutes";
export default function NewDiscussion() {
    const [discussionTopics, setDiscussionTopics] = useState<IDiscussionTopic | any>([]);
    const navigate = useNavigate();
    const toast = useToast();
    const params = useParams();
    const course_id:any = params.course_id;
    const discussion_id:any = params.discussion_id;

    useEffect(()=>{
        if (course_id)
            trainercoursesService.getDiscussionTopics(course_id).then(
                (res) => {
                    
                    setDiscussionTopics(res.data);
                }
            )
        }, [])

    
    const formik = useFormik({
        validate: (values: any) => {
            const errors: any = {};
            if (!values.message) {
                errors.message = 'description is required'
            }
           
            return errors;
        },
        initialValues: {
            message: '',
       
        },
        onSubmit: async (values) => {

            const newDiscussionInfo: any = {
                message: values.message,
            }
            
            try {
                const  newDiscussionResponse = await trainercoursesService.createNewDiscussion(newDiscussionInfo, discussion_id)
                
                if(newDiscussionResponse.status === 'success')
                    toast({
                        title: "Discussion",
                        description: 'New Discussion Created',
                        status: "success",
                    })
            }
            catch (error:any) {
                toast({
                    title: "Discussion",
                    description: `${error.response.data.message}`,
                    status: "error",
                })
            }
        }
    })
    return (
        <Box minHeight="100vh" bg="#F9F8F8" >

            <Container
                width={"58%"}
                maxWidth={"84%"}
                px={0}
                pt='100px'
                right={0}
                bg="F9F8F8"
                mx='auto'
            >

                <Box
                    mb='60px'
                    display="flex"
                    alignItems="center"
                    border="1px solid #616161"
                    px="5px"
                    py="7px"
                    width="190px"
                    borderRadius="5px"
                    cursor="pointer"
                >
                    <HiArrowNarrowLeft color="#616161" fontSize="20px" />
                    <Text fontSize="14px" color="#616161" pl="5px" onClick={() => navigate(courseRoutes.DiscussionsLink(course_id))} fontWeight={700}>
                        Back to discussions
                    </Text>
                </Box>
                <Box bg='white' px='40px' py='60px'>
                    <Text>New Discussion</Text>

                    <Box mt={4}>
                        <form onSubmit={formik.handleSubmit} >
                            <FormControl id="groupDescription" mt={6} isInvalid={(formik.errors.message && formik.touched.message) ? true : false}>
                                <FormLabel fontWeight="normal" color="brand.3" fontSize={13}>write here..</FormLabel>
                                <Textarea
                                    p={4}
                                    bg="inputText.500"
                                    fontSize={12}
                                    size="sm"
                                    minH="10rem"
                                    placeholder="Enter Description"
                                    name="message"
                                    id="message"
                                    onChange={formik.handleChange}
                                    value={formik.values.message}
                                />
                                <FormErrorMessage fontSize={12} >{formik.errors.message}</FormErrorMessage>
                            </FormControl>




                            <Flex mt={12} justifyContent="center">

                                <Button colorScheme="red" type="submit" isLoading={formik.isSubmitting}

                                    size="sm" px={6} fontSize={14} > POST DISCUSSION</Button>
                            </Flex>
                        </form>
                    </Box>
                </Box>
            </Container>
        </Box>
    );
}
